/*! canvora-reviews.js v1 - product review flow for canvora.co. Vanilla ES2018, no dependencies. */
(function () {
  'use strict';
  var VERSION = '1', MAX_PHOTOS = 3, MAX_SIDE = 1600, MAX_BYTES = 1300000, MAX_INPUT = 30 * 1048576;
  var HANDLE_RE = /^[a-z0-9][a-z0-9-]{0,254}$/, K_RE = /^[0-9a-f]{12}$/i, NS = 'http://www.w3.org/2000/svg';
  var supported = !!(window.fetch && window.Promise), seq = 0, cfg = null, modal = null;
  var PATHS = { star: 'M12 2.5L14.9 8.9L21.8 9.6L16.6 14.2L18.1 21L12 17.5L5.9 21L7.4 14.2L2.2 9.6L9.1 8.9Z', x: 'M6 6L18 18M18 6L6 18', back: 'M15 5L8 12L15 19' };
  var TXT = {
    network: "We couldn't reach the server. Check your connection and try again.",
    rate_limited: 'Too many attempts just now. Please wait a little while and try again.',
    verify: 'Please confirm you bought this piece, or sign in to confirm your email.',
    duplicate: "You've already reviewed this piece. Thank you!",
    invalid: "Something in your review couldn't be accepted. Please check it and try again.",
    too_large: 'Your photos are too large to send together. Please remove one and try again.',
    other: 'Something went wrong on our side. Please try again in a moment.'
  };
  var PHOTO = {
    type: "That file isn't an image. Please choose a JPG, PNG or WebP photo.",
    big: 'That photo is too large to upload. Please choose a smaller one.',
    heic: "That looks like a HEIC photo, which this browser can't open. Please choose a JPG or PNG, or set your camera to its most compatible format.",
    decode: "We couldn't read that file as a photo. Please try a different one."
  };

  // ---------- small helpers ----------
  function getCfg() {
    if (cfg) return cfg;
    cfg = { endpoint: 'https://forms.lordimboard.com', login_url: '/account/login', contact_url: '/pages/contact', signin: null, privacy_url: '/policies/privacy-policy', support_email: 'support@canvora.co' };
    try {
      var c = JSON.parse(document.getElementById('cvrv-config').textContent);
      Object.keys(c).forEach(function (k) { if (c[k] != null) cfg[k] = c[k]; });
    } catch (e) { console.error('CanvoraReviews: #cvrv-config is missing or is not valid JSON'); }
    cfg.endpoint = String(cfg.endpoint).replace(/\/+$/, '');
    var s = cfg.signin;
    if (s && !(s.cid && s.sig && s.ts && K_RE.test(s.k || ''))) cfg.signin = null;
    return cfg;
  }
  function add(el, kids) {
    if (kids == null || kids === false) return;
    if (Array.isArray(kids)) kids.forEach(function (c) { add(el, c); });
    else el.appendChild(kids.nodeType ? kids : document.createTextNode(String(kids)));
  }
  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      var v = attrs[k];
      if (v == null || v === false) return;
      if (k.slice(0, 2) === 'on') el.addEventListener(k.slice(2), v);
      else if (k === 'value' || k === 'checked') el[k] = v;
      else el.setAttribute(k, v === true ? '' : v);
    });
    add(el, kids);
    return el;
  }
  function icon(name, cls) {
    var s = document.createElementNS(NS, 'svg'), p = document.createElementNS(NS, 'path');
    s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false');
    if (cls) s.setAttribute('class', cls);
    p.setAttribute('d', PATHS[name]); s.appendChild(p);
    return s;
  }
  function safeImg(u) {
    try {
      var x = new URL(u, location.href);
      if (/^https?:$/.test(x.protocol) && (x.origin === location.origin || /(^|\.)shopify\.com$/.test(x.hostname))) return x.href;
    } catch (e) { /* ignore */ }
    return '';
  }
  function thumb(src, cls) {
    var u = safeImg(src);
    if (!u) return h('span', { class: cls + ' is-empty' });
    var im = h('img', { class: cls, src: u, alt: '', loading: 'lazy' });
    im.addEventListener('error', function () { im.replaceWith(h('span', { class: cls + ' is-empty' })); });
    return im;
  }
  function field(id, label, input, o) {
    o = o || {};
    var kids = [h('label', { class: 'cvrv-label', for: id }, [label, o.opt && h('span', { class: 'cvrv-opt' }, ' (optional)')]), input], desc = [];
    input.id = id;
    if (o.extra) { kids.push(o.extra); desc.push(o.extra.id); }
    if (o.help) { kids.push(h('p', { class: 'cvrv-help', id: id + '-h' }, o.help)); desc.push(id + '-h'); }
    kids.push(h('p', { class: 'cvrv-err', id: id + '-e', role: 'alert', hidden: true })); desc.push(id + '-e');
    input.setAttribute('aria-describedby', desc.join(' '));
    return h('div', { class: 'cvrv-field' }, kids);
  }
  function bad(input, msg) {
    var e = document.getElementById(input.id + '-e');
    input.setAttribute('aria-invalid', 'true'); e.textContent = msg; e.hidden = false;
  }
  function unbad(input) {
    var e = document.getElementById(input.id + '-e');
    input.removeAttribute('aria-invalid'); if (e) e.hidden = true;
  }
  function errText(e) { return (e.code === 'network' ? '' : e.message) || TXT[e.code] || TXT.other; }
  function draftKey(hd) { return 'cvrv:draft:' + hd; }
  function draftGet(hd) {
    try { var d = JSON.parse(sessionStorage.getItem(draftKey(hd))); return d && Date.now() - d.t < 6 * 36e5 && d.rating > 0 && d.body ? d : null; } catch (e) { return null; }
  }
  function draftSet(hd, v) {
    try { if (v) { v.t = Date.now(); sessionStorage.setItem(draftKey(hd), JSON.stringify(v)); } else sessionStorage.removeItem(draftKey(hd)); } catch (e) { /* storage unavailable */ }
  }

  // ---------- network + crypto ----------
  async function api(path, body) {
    var ctl = window.AbortController ? new AbortController() : null, timer = ctl && setTimeout(function () { ctl.abort(); }, 60000), res, data;
    try {
      res = await fetch(getCfg().endpoint + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), credentials: 'omit', signal: ctl ? ctl.signal : undefined });
      data = await res.json().catch(function () { return {}; });
    } catch (e) { throw { code: 'network' }; } finally { clearTimeout(timer); }
    if (data && data.ok) return data;
    throw { code: (data && data.error) || (res.status === 413 ? 'too_large' : res.status === 429 ? 'rate_limited' : 'other'), message: (data && data.message) || '' };
  }
  async function khash(email) {
    var d = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(String(email).trim().toLowerCase()));
    return Array.prototype.map.call(new Uint8Array(d), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('').slice(0, 12);
  }

  // ---------- photos: decode, downscale to 1600 px, re-encode as JPEG ----------
  function viaImg(file) {
    return new Promise(function (res, rej) {
      var u = URL.createObjectURL(file), im = new Image();
      im.onload = function () { URL.revokeObjectURL(u); res(im); };
      im.onerror = function () { URL.revokeObjectURL(u); rej(new Error('decode')); };
      im.src = u;
    });
  }
  function readUrl(blob) {
    return new Promise(function (res, rej) { var r = new FileReader(); r.onload = function () { res(r.result); }; r.onerror = rej; r.readAsDataURL(blob); });
  }
  async function shrink(file) {
    var heic = /hei[cf]/i.test(file.type + ' ' + file.name);
    if (!/^image\//.test(file.type) && !heic && !/\.(jpe?g|png|webp|gif|bmp)$/i.test(file.name)) throw { code: 'type' };
    if (file.size > MAX_INPUT) throw { code: 'big' };
    var src;
    try { src = window.createImageBitmap ? await createImageBitmap(file, { imageOrientation: 'from-image' }).catch(function () { return viaImg(file); }) : await viaImg(file); } catch (e) { throw { code: heic ? 'heic' : 'decode' }; }
    var w = src.naturalWidth || src.width, ht = src.naturalHeight || src.height, sc = Math.min(1, MAX_SIDE / Math.max(w, ht));
    var cv = document.createElement('canvas'), cx = cv.getContext('2d');
    cv.width = Math.max(1, Math.round(w * sc)); cv.height = Math.max(1, Math.round(ht * sc));
    cx.fillStyle = '#fff'; cx.fillRect(0, 0, cv.width, cv.height); cx.drawImage(src, 0, 0, cv.width, cv.height);
    if (src.close) src.close();
    for (var q = 0.85; q > 0.3; q -= 0.15) {
      var blob = await new Promise(function (r) { cv.toBlob(r, 'image/jpeg', q); });
      if (blob && blob.size <= MAX_BYTES) return { url: await readUrl(blob), w: cv.width, h: cv.height };
    }
    throw { code: 'big' };
  }

  // ---------- the review flow (one product), rendered into `root` ----------
  // o: { product:{handle,title,image}, order:{id,k}|null, mode:'modal'|'page', onClose, onBack, onReviewed, more }
  function Flow(root, o) {
    var C = getCfg(), uid = 'cvrv' + (++seq) + '-', P = o.product, si = C.signin, step = 'rating', ui = {};
    var S = { rating: 0, title: '', body: '', name: '', email: '', order: '', agree: false, hp: '', photos: [], busy: 0, sending: false, result: null, restored: false };
    var bar = h('span'), stage = h('div', { class: 'cvrv-step' }), live = h('p', { class: 'cvrv-sr', role: 'status', 'aria-live': 'polite' });
    var dr = draftGet(P.handle);
    if (dr) { S.rating = dr.rating; S.title = dr.title || ''; S.body = dr.body; S.name = dr.name || ''; S.order = dr.order || ''; S.restored = true; step = 'about'; }
    add(root, h('div', { class: 'cvrv-flow' }, [h('div', { class: 'cvrv-progress', 'aria-hidden': 'true' }, bar), stage, live]));

    function say(m) { live.textContent = m; }
    function hd(t) { return h('h2', { class: 'cvrv-h', tabindex: '-1' }, t); }
    function btn(label, fn, cls) { return h('button', { type: fn ? 'button' : 'submit', class: 'cvrv-btn ' + (cls || ''), onclick: fn }, label); }
    function actions(kids) { return h('div', { class: 'cvrv-actions' }, kids); }
    function order() { return S.rating && S.rating <= 3 ? ['rating', 'tell', 'review', 'photos', 'about'] : ['rating', 'review', 'photos', 'about']; }
    function go(s) { step = s; render(); }
    function move(d) { var a = order(); go(a[Math.max(0, a.indexOf(step) + d)]); }
    function render() {
      var a = order(), i = a.indexOf(step), back = null;
      if (step !== 'thanks' && (i > 0 || o.onBack)) back = h('button', { type: 'button', class: 'cvrv-back', onclick: i > 0 ? function () { move(-1); } : o.onBack }, [icon('back'), i > 0 ? 'Back' : 'All pieces']);
      bar.style.width = (step === 'thanks' ? 100 : Math.round((i + 1) / a.length * 100)) + '%';
      stage.textContent = ''; stage.setAttribute('data-step', step);
      add(stage, [back, V[step]()]);
      var head = stage.querySelector('.cvrv-h'); if (head) head.focus();
    }
    function summary() {
      var stars = [1, 2, 3, 4, 5].map(function (n) { return icon('star', n <= S.rating ? 'is-on' : ''); });
      return h('div', { class: 'cvrv-sum' }, [thumb(P.image, 'cvrv-thumb'), h('div', { class: 'cvrv-sumtxt' }, [h('p', { class: 'cvrv-ptitle' }, P.title), h('span', { class: 'cvrv-mini', role: 'img', 'aria-label': 'Your rating: ' + S.rating + ' out of 5' }, stars)])]);
    }

    var V = {
      rating: function () {
        var btns = [], grp;
        function paint(n) { btns.forEach(function (b, i) { b.classList.toggle('is-on', i < n); }); }
        function pick(n) { S.rating = n; move(1); }
        function focusStar(n) { btns.forEach(function (b, i) { b.tabIndex = i === n - 1 ? 0 : -1; }); btns[n - 1].focus(); }
        [1, 2, 3, 4, 5].forEach(function (n) {
          btns.push(h('button', {
            type: 'button', class: 'cvrv-star', role: 'radio', 'aria-checked': String(S.rating === n), tabindex: (S.rating || 1) === n ? '0' : '-1',
            'aria-label': n + (n === 1 ? ' star, poor' : n === 5 ? ' stars, great' : ' stars'),
            onclick: function () { pick(n); }, onmouseenter: function () { paint(n); }, onfocus: function () { paint(n); },
            onkeydown: function (e) {
              var d = { ArrowRight: 1, ArrowUp: 1, ArrowLeft: -1, ArrowDown: -1 }[e.key];
              if (d) { e.preventDefault(); focusStar(Math.min(5, Math.max(1, n + d))); }
              else if (e.key === 'Home' || e.key === 'End') { e.preventDefault(); focusStar(e.key === 'Home' ? 1 : 5); }
              else if (/^[1-5]$/.test(e.key)) pick(+e.key);
            }
          }, icon('star')));
        });
        grp = h('div', {
          class: 'cvrv-stars', role: 'radiogroup', 'aria-label': 'Your rating',
          onmouseleave: function () { if (!grp.contains(document.activeElement)) paint(S.rating); },
          onfocusout: function (e) { if (!grp.contains(e.relatedTarget)) paint(S.rating); }
        }, btns);
        paint(S.rating);
        return [hd('How would you rate this piece?'),
          h('div', { class: 'cvrv-prod' }, [thumb(P.image, 'cvrv-thumb cvrv-thumb--lg'), h('p', { class: 'cvrv-ptitle' }, P.title)]),
          h('div', { class: 'cvrv-rate' }, [grp, h('div', { class: 'cvrv-scale', 'aria-hidden': 'true' }, [h('span', null, 'Poor'), h('span', null, 'Great')])])];
      },

      tell: function () {
        // Both buttons share one style on purpose: this step must never steer people away from reviewing.
        return [hd('Tell us more'), h('p', { class: 'cvrv-lead' }, "Your experience matters to us. If something went wrong with your order, we're here to help."),
          actions([h('a', { class: 'cvrv-btn', href: C.contact_url, target: '_blank', rel: 'noopener noreferrer' }, 'Contact us'), btn('Leave a review', function () { move(1); })])];
      },

      review: function () {
        var t = h('input', { type: 'text', class: 'cvrv-input', maxlength: '120', autocomplete: 'off', placeholder: 'Give your review a title', value: S.title, oninput: function () { S.title = t.value; } });
        var b = h('textarea', { class: 'cvrv-input cvrv-ta', maxlength: '5000', rows: '6', required: true, 'aria-required': 'true', placeholder: 'Start writing here...', oninput: function () { S.body = b.value; unbad(b); count(); } });
        var cnt = h('p', { class: 'cvrv-count', id: uid + 'cnt', hidden: true });
        b.value = S.body;
        function count() { cnt.hidden = b.value.length <= 4500; cnt.textContent = b.value.length + ' / 5000'; }
        count();
        return [hd('Your review'), summary(), h('form', {
          novalidate: true, onsubmit: function (e) { e.preventDefault(); if (!b.value.trim()) { bad(b, 'Please write a few words about this piece.'); b.focus(); } else move(1); }
        }, [field(uid + 't', 'Title', t, { opt: true }), field(uid + 'b', 'Review', b, { extra: cnt }), actions(btn('Continue'))])];
      },

      photos: function () {
        var grid = h('ul', { class: 'cvrv-thumbs' }), msg = h('p', { class: 'cvrv-err', role: 'alert', hidden: true }), go1 = btn('Skip', function () { move(1); });
        var inp = h('input', { type: 'file', accept: 'image/*', multiple: true, class: 'cvrv-sr', id: uid + 'file', onchange: function () { take(inp.files); } });
        var drop = h('label', { class: 'cvrv-drop', for: uid + 'file' }, [h('strong', null, 'Choose photos'), h('span', null, 'or drag and drop them here'), h('small', null, 'Up to ' + MAX_PHOTOS + ' images. JPG, PNG or WebP.'), inp]);
        ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
        ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); if (ev === 'drop' && e.dataTransfer) take(e.dataTransfer.files); }); });
        function paint() {
          grid.textContent = '';
          S.photos.forEach(function (p, i) {
            grid.appendChild(h('li', null, [h('img', { src: p.url, alt: 'Photo ' + (i + 1) + ' of your review' }), h('button', { type: 'button', class: 'cvrv-rm', 'aria-label': 'Remove photo ' + (i + 1), onclick: function () { S.photos.splice(i, 1); say('Photo removed.'); paint(); } }, icon('x'))]));
          });
          grid.hidden = !S.photos.length; drop.hidden = S.photos.length >= MAX_PHOTOS;
          go1.textContent = S.photos.length ? 'Continue' : 'Skip'; go1.disabled = S.busy > 0;
        }
        function fail(m) { msg.textContent = (msg.hidden ? '' : msg.textContent + ' ') + m; msg.hidden = false; }
        async function take(list) {
          var files = [].slice.call(list), room = MAX_PHOTOS - S.photos.length;
          inp.value = ''; msg.hidden = true;
          if (files.length > room) { fail('You can add up to ' + MAX_PHOTOS + ' photos.'); files = files.slice(0, room); }
          for (var i = 0; i < files.length; i++) {
            S.busy++; paint(); say('Preparing your photo...');
            try { S.photos.push(await shrink(files[i])); say('Photo added.'); } catch (e) { fail(files[i].name + ': ' + (PHOTO[e.code] || PHOTO.decode)); }
            S.busy--; paint();
          }
        }
        paint();
        return [hd('Share a picture'), summary(), h('p', { class: 'cvrv-lead' }, 'Upload a photo of it on your wall.'), drop, msg, grid, actions(go1)];
      },

      about: function () {
        var showMail = !o.order && (!si || si.email), locked = !o.order && si;
        var nm = h('input', { type: 'text', class: 'cvrv-input', maxlength: '60', autocomplete: 'off', required: true, 'aria-required': 'true', placeholder: (si && si.name) || 'First name and last initial', value: S.name, oninput: function () { S.name = nm.value; unbad(nm); } });
        var em = showMail && h('input', { type: 'email', class: 'cvrv-input', autocomplete: 'email', required: true, 'aria-required': 'true', readonly: locked, value: locked ? si.email : S.email, oninput: function () { S.email = em.value; unbad(em); } });
        var on = !o.order && !si && h('input', { type: 'text', class: 'cvrv-input', autocomplete: 'off', placeholder: '#1001', value: S.order, oninput: function () { S.order = on.value; } });
        var ag = h('input', { type: 'checkbox', id: uid + 'ag', checked: S.agree, 'aria-required': 'true', 'aria-describedby': uid + 'ag-e', onchange: function () { S.agree = ag.checked; unbad(ag); } });
        var hp = h('input', { type: 'text', name: 'hp', tabindex: '-1', autocomplete: 'off', oninput: function () { S.hp = hp.value; } });
        ui.nm = nm; ui.em = em; ui.ag = ag; ui.box = h('div', { class: 'cvrv-alerts' });
        ui.btn = h('button', { type: 'submit', class: 'cvrv-btn' }, 'Submit review'); ui.label = 'Submit review';
        return [hd('About you'), summary(), S.restored && h('p', { class: 'cvrv-help' }, 'Your review is saved. Finish this last step to send it.'),
          h('form', { novalidate: true, onsubmit: function (e) { e.preventDefault(); submit(); } }, [
            field(uid + 'n', 'Display name', nm, { help: 'Shown with your review' }),
            em && field(uid + 'e', 'Email', em, { help: 'Private. Never shown.' }),
            on && field(uid + 'o', 'Did you buy it on canvora.co?', on, { opt: true, help: 'Add your order number to confirm your purchase. You can find it in your order confirmation email.' }),
            h('label', { class: 'cvrv-check' }, [ag, h('span', null, 'I confirm this is my honest review and canvora.co may publish it.')]),
            h('p', { class: 'cvrv-err', id: uid + 'ag-e', role: 'alert', hidden: true }),
            h('div', { class: 'cvrv-hp', 'aria-hidden': 'true' }, h('label', null, ['Leave this field empty', hp])),
            h('p', { class: 'cvrv-help' }, h('a', { href: C.privacy_url, target: '_blank', rel: 'noopener' }, 'Privacy policy')),
            ui.box, actions(ui.btn)])];
      },

      thanks: function () {
        var r = S.result, kids = [hd('Thanks for your review!'), h('p', { class: 'cvrv-lead' }, r.status === 'approved' ? 'It will appear on the store shortly.' : "We'll publish it after a quick check.")];
        if (r.coupon) kids.push(couponBox(r.coupon));
        else if (r.coupon_reason === 'later') kids.push(h('p', { class: 'cvrv-note' }, ["Your 10% code couldn't be issued just now. Write to ", h('a', { href: 'mailto:' + C.support_email }, C.support_email), " with the name on your review and we'll send it."]));
        if (o.more && o.more()) kids.push(actions(btn('Review another piece', o.onClose)));
        else if (o.mode === 'modal') kids.push(actions(btn('Close', o.onClose)));
        return kids;
      }
    };

    function couponBox(code) {
      var codeEl = h('code', { class: 'cvrv-code' }, code), copy = h('button', { type: 'button', class: 'cvrv-btn cvrv-btn--ghost', onclick: doCopy }, 'Copy');
      function pickText() { var r = document.createRange(); r.selectNodeContents(codeEl); var s = window.getSelection(); s.removeAllRanges(); s.addRange(r); }
      async function doCopy() {
        try { await navigator.clipboard.writeText(code); } catch (e) {
          pickText();
          try { if (!document.execCommand('copy')) throw e; } catch (e2) { say('The code is selected. Press Ctrl+C or Cmd+C to copy it.'); return; }
        }
        copy.textContent = 'Copied'; say('Code copied.');
        setTimeout(function () { copy.textContent = 'Copy'; }, 2200);
      }
      return h('div', { class: 'cvrv-coupon' }, [h('h3', { class: 'cvrv-h3' }, "Here's 10% off your next order"), h('div', { class: 'cvrv-codes' }, [codeEl, copy]),
        h('a', { class: 'cvrv-btn', href: '/discount/' + encodeURIComponent(code) }, 'Use it now'),
        h('p', { class: 'cvrv-fine' }, "One use. Doesn't combine with the 2+ pieces saving; checkout applies whichever saves you more.")]);
    }

    function busy(on) {
      ui.btn.disabled = on; ui.btn.textContent = '';
      add(ui.btn, on ? [h('span', { class: 'cvrv-spin', 'aria-hidden': 'true' }), 'Submitting...'] : ui.label);
      say(on ? 'Submitting your review...' : '');
    }
    function showAlert(kind, title, msg, extra) {
      var box = h('div', { class: 'cvrv-banner cvrv-banner--' + kind, role: 'alert', tabindex: '-1' }, [title && h('strong', null, title), h('p', null, msg), extra]);
      ui.box.textContent = ''; ui.box.appendChild(box); box.focus();
    }
    function needSignin(msg) {
      draftSet(P.handle, { rating: S.rating, title: S.title, body: S.body, name: S.name, order: S.order });
      showAlert('info', 'Please sign in to confirm your email', msg, h('a', { class: 'cvrv-btn', href: C.login_url }, 'Sign in'));
    }
    async function submit() {
      if (S.sending) return;
      var errs = [];
      if (!S.name.trim()) errs.push([ui.nm, 'Please enter the name to show with your review.']);
      if (ui.em && !ui.em.readOnly && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(S.email.trim())) errs.push([ui.em, 'Please enter a valid email address.']);
      if (!S.agree) errs.push([ui.ag, 'Please tick the box to confirm.']);
      errs.forEach(function (x) { bad(x[0], x[1]); });
      if (errs.length) { errs[0][0].focus(); return; }
      S.sending = true; ui.box.textContent = ''; busy(true);
      ui.label = 'Submit review';
      try {
        var proof, k;
        if (o.order) {
          proof = { type: 'order', order_id: o.order.id }; k = o.order.k;
          if (si && si.k === k) proof = [proof, { type: 'signin', cid: si.cid, ts: si.ts, sig: si.sig }]; // an order the index hasn't seen still has the sign-in
        }
        else if (si) { proof = { type: 'signin', cid: si.cid, ts: si.ts, sig: si.sig }; k = si.k; }
        else {
          k = await khash(S.email);
          if (S.order.trim()) {
            try { proof = { type: 'order', order_id: (await api('/v1/order-lookup', { order: S.order.trim(), k: k })).order_id }; } catch (e) { if (e.code !== 'not_found') throw e; }
          }
          if (!proof) return needSignin(S.order.trim() ? "We couldn't find an order with that number and email. Check them and try again, or sign in to confirm your email." : 'Without an order number we confirm reviews by signing in, so we know the email is yours. Your review is saved while you do.');
        }
        var body = { handle: P.handle, product_title: P.title, rating: S.rating, body: S.body.trim(), name: S.name.trim(), k: k, proof: proof, photos: S.photos.map(function (p) { return p.url; }), publish_ok: true, hp: S.hp };
        if (S.title.trim()) body.title = S.title.trim();
        S.result = await api('/v1/review', body);
        draftSet(P.handle, null);
        if (o.onReviewed) o.onReviewed(P.handle);
        S.sending = false; say('Thank you. Your review was sent.'); go('thanks');
      } catch (e) {
        if (e.code === 'verify') return needSignin(errText(e));
        if (e.code === 'duplicate' && o.onReviewed) o.onReviewed(P.handle);
        if (e.code === 'network' || e.code === 'rate_limited' || e.code === 'other' || e.code === 'too_large') ui.label = 'Try again';
        showAlert('error', '', errText(e));
      } finally { S.sending = false; if (ui.btn.isConnected) { ui.btn.disabled = false; busy(false); } }
    }

    render();
    if (S.restored) say('Your saved review has been restored.');
    return { dirty: function () { return step !== 'thanks' && !!(S.title || S.body || S.photos.length); } };
  }

  // ---------- modal ----------
  function open(handle, title, image) {
    if (!supported || modal) return;
    handle = String(handle || '').trim().toLowerCase();
    if (!HANDLE_RE.test(handle)) { console.error('CanvoraReviews: invalid product handle'); return; }
    var prev = document.activeElement, down = false, flow, sb = window.innerWidth - document.documentElement.clientWidth;
    var ov = h('div', { class: 'cvrv-overlay cvrv-root' }), body = h('div'), dlg = h('div', { class: 'cvrv-dialog', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Write a review', tabindex: '-1' });
    var shut = [].filter.call(document.body.children, function (n) { return n.tagName !== 'SCRIPT' && !n.inert; });
    function close() {
      document.removeEventListener('keydown', onKey, true);
      ov.remove(); shut.forEach(function (n) { n.inert = false; });
      document.documentElement.classList.remove('cvrv-lock'); document.body.style.paddingRight = '';
      modal = null;
      if (prev && prev.isConnected && prev.focus) prev.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = [].filter.call(dlg.querySelectorAll('a[href],button,input,textarea,select,[tabindex]'), function (n) { return n.tabIndex >= 0 && !n.disabled && n.offsetParent !== null; });
      if (!f.length) { e.preventDefault(); dlg.focus(); return; }
      var first = f[0], last = f[f.length - 1];
      if (!dlg.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && (document.activeElement === first || document.activeElement === dlg)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    ov.addEventListener('mousedown', function (e) { down = e.target === ov; });
    ov.addEventListener('click', function (e) { if (down && e.target === ov && !(flow && flow.dirty())) close(); });
    add(dlg, [h('button', { type: 'button', class: 'cvrv-x', 'aria-label': 'Close', onclick: close }, icon('x')), body]);
    ov.appendChild(dlg);
    document.body.appendChild(ov);
    shut.forEach(function (n) { if (n !== ov) n.inert = true; });
    document.documentElement.classList.add('cvrv-lock'); if (sb > 0) document.body.style.paddingRight = sb + 'px';
    document.addEventListener('keydown', onKey, true);
    modal = ov;
    // A signed-in shopper who bought this piece (config.orders, rendered by Liquid from customer.orders) reviews as a buyer.
    var ord = null;
    (getCfg().orders || []).some(function (x) { if (x && x.id && K_RE.test(x.k || '') && (x.handles || []).indexOf(handle) >= 0) { ord = { id: String(x.id), k: String(x.k).toLowerCase() }; return true; } return false; });
    flow = Flow(body, { product: { handle: handle, title: String(title || handle.replace(/-/g, ' ')).slice(0, 200), image: image }, order: ord, mode: 'modal', onClose: close });
  }

  // ---------- page mode: [data-cvrv-page] ----------
  function Page(mount) {
    var C = getCfg(), q = new URLSearchParams(location.search), login = mount.getAttribute('data-login-url') || C.login_url, done = {}, found = null, pid = 'cvrvp' + (++seq) + '-';
    mount.classList.add('cvrv-root', 'cvrv-page');
    function show(n, focus) { mount.textContent = ''; add(mount, n); var x = focus && mount.querySelector('.cvrv-h'); if (x) x.focus(); }
    function head(t) { return h('h2', { class: 'cvrv-h', tabindex: '-1' }, t); }
    function lookup(ref, k) { return api('/v1/order-lookup', { order: ref, k: k }).then(function (d) { d.k = k; return d; }); }
    function start(item) {
      var box = h('div', { class: 'cvrv-panel' });
      show(box);
      Flow(box, { product: item, order: found && { id: found.order_id, k: found.k }, mode: 'page', onBack: found ? function () { list(true); } : null, onClose: function () { list(true); }, onReviewed: function (x) { done[x] = 1; }, more: found && function () { return found.items.some(function (i) { return !done[i.handle]; }); } });
    }
    function list(focus) {
      var cards = found.items.map(function (it) {
        return h('li', { class: 'cvrv-card' }, [thumb(it.image, 'cvrv-thumb cvrv-thumb--md'), h('p', { class: 'cvrv-ptitle' }, it.title),
          done[it.handle] ? h('span', { class: 'cvrv-done' }, 'Reviewed — thank you') : h('button', { type: 'button', class: 'cvrv-btn', 'aria-label': 'Write a review for ' + it.title, onclick: function () { start(it); } }, 'Write a review')]);
      });
      show([head('Review your pieces'), h('p', { class: 'cvrv-lead' }, 'Order ' + found.name + '. Choose a piece to review.'), cards.length ? h('ul', { class: 'cvrv-cards' }, cards) : h('p', { class: 'cvrv-note' }, 'There are no pieces to review on this order.')], focus);
    }
    function finder(msg) {
      var no = h('input', { type: 'text', class: 'cvrv-input', autocomplete: 'off', placeholder: '#1001', required: true, 'aria-required': 'true', oninput: function () { unbad(no); } });
      var em = h('input', { type: 'email', class: 'cvrv-input', autocomplete: 'email', required: true, 'aria-required': 'true', oninput: function () { unbad(em); } });
      var box = h('div'), go1 = h('button', { type: 'submit', class: 'cvrv-btn' }, 'Find my order');
      function note(m) { box.textContent = ''; box.appendChild(h('div', { class: 'cvrv-banner cvrv-banner--error', role: 'alert' }, h('p', null, m))); }
      show([head('Find your order'), h('p', { class: 'cvrv-lead' }, 'Enter your order number and the email you used at checkout.'), h('form', {
        novalidate: true, onsubmit: async function (e) {
          e.preventDefault(); if (go1.disabled) return;
          if (!no.value.trim()) { bad(no, 'Please enter your order number.'); no.focus(); return; }
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value.trim())) { bad(em, 'Please enter a valid email address.'); em.focus(); return; }
          go1.disabled = true; box.textContent = '';
          try { found = await lookup(no.value.trim(), await khash(em.value)); list(true); } catch (x) {
            note(x.code === 'not_found' ? "We couldn't find an order with that number and email. Please check both and try again." : errText(x)); go1.disabled = false;
          }
        }
      }, [field(pid + 'o', 'Order number', no), field(pid + 'e', 'Email', em, { help: 'The email you used at checkout. Private. Never shown.' }), box, h('div', { class: 'cvrv-actions' }, go1)]),
        h('p', { class: 'cvrv-help cvrv-alt' }, h('a', { href: login }, "Didn't buy from canvora.co? Sign in to review"))]);
      if (msg) note(msg);
    }
    var o = q.get('o'), k = (q.get('k') || '').toLowerCase(), hd = (q.get('h') || '').trim().toLowerCase();
    var direct = HANDLE_RE.test(hd) ? { handle: hd, title: (q.get('t') || hd.replace(/-/g, ' ')).slice(0, 200), image: q.get('i') } : null;
    if (o && K_RE.test(k)) {
      show(h('p', { class: 'cvrv-lead', role: 'status' }, 'Looking up your order...'));
      lookup(o, k).then(function (d) {
        found = d;
        if (direct) start(d.items.filter(function (i) { return i.handle === hd; })[0] || direct); else list(false);
      }).catch(function (e) { finder(e.code === 'not_found' ? "We couldn't find that order. The link may be out of date, but you can look it up below." : errText(e)); });
    } else if (direct) start(direct);
    else finder();
  }

  // ---------- boot ----------
  function init() {
    if (!supported) {
      [].forEach.call(document.querySelectorAll('[data-cvrv-open]'), function (t) { t.hidden = true; });
      [].forEach.call(document.querySelectorAll('[data-cvrv-page]'), function (m) { m.textContent = 'Reviews are not available in this browser. Please try a current version of Chrome, Safari, Firefox or Edge.'; });
      return;
    }
    getCfg();
    function fire(t) { open(t.getAttribute('data-handle'), t.getAttribute('data-title'), t.getAttribute('data-image')); }
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-cvrv-open]');
      if (t) { e.preventDefault(); fire(t); }
    });
    document.addEventListener('keydown', function (e) {
      var t = e.target.closest && e.target.closest('[data-cvrv-open]');
      if (t && (e.key === 'Enter' || e.key === ' ') && !/^(BUTTON|A|INPUT)$/.test(t.tagName)) { e.preventDefault(); fire(t); }
    });
    var triggers = [].slice.call(document.querySelectorAll('[data-cvrv-open]'));
    triggers.forEach(function (t) {
      t.setAttribute('aria-haspopup', 'dialog');
      if (!/^(BUTTON|A|INPUT)$/.test(t.tagName)) { t.setAttribute('role', 'button'); t.tabIndex = 0; }
    });
    [].forEach.call(document.querySelectorAll('[data-cvrv-page]'), Page);
    // Back from sign-in with a saved draft: reopen that piece's review.
    if (getCfg().signin) {
      var back = triggers.filter(function (t) { return draftGet((t.getAttribute('data-handle') || '').toLowerCase()); })[0];
      if (back) fire(back);
    }
  }

  window.CanvoraReviews = { open: open, version: VERSION };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
